import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import ShrinkOutlinedSvg from "@ant-design/icons-svg/es/asn/ShrinkOutlined";
import AntdIcon from "../components/AntdIcon";
var ShrinkOutlined = function ShrinkOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: ShrinkOutlinedSvg
  }));
};

/**![shrink](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTg4MS43IDE4Ny40bC00NS4xLTQ1LjFhOC4wMyA4LjAzIDAgMDAtMTEuMyAwTDY2Ny44IDI5OS45bC01NC43LTU0LjdhNy45NCA3Ljk0IDAgMDAtMTMuNSA0LjdMNTc2LjEgNDM5Yy0uNiA1LjIgMy43IDkuNSA4LjkgOC45bDE4OS4yLTIzLjVjNi42LS44IDkuMy04LjggNC43LTEzLjVsLTU0LjctNTQuNyAxNTcuNi0xNTcuNmMzLTMgMy04LjEtLjEtMTEuMnpNNDM5IDU3Ni4xbC0xODkuMiAyMy41Yy02LjYuOC05LjMgOC45LTQuNyAxMy41bDU0LjcgNTQuNy0xNTcuNSAxNTcuNWE4LjAzIDguMDMgMCAwMDAgMTEuM2w0NS4xIDQ1LjFjMy4xIDMuMSA4LjIgMy4xIDExLjMgMGwxNTcuNi0xNTcuNiA1NC43IDU0LjdhNy45NCA3Ljk0IDAgMDAxMy41LTQuN0w0NDcuOSA1ODVhNy45IDcuOSAwIDAwLTguOS04Ljl6IiAvPjwvc3ZnPg==) */
var RefIcon = /*#__PURE__*/React.forwardRef(ShrinkOutlined);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ShrinkOutlined';
}
export default RefIcon;